import { applySpeakerRename } from '../components/protocol/speakerLabels';

// Текст расшифровки живёт в двух состояниях: вкладка «Транскрибация» и экран
// «Протокол» (в него текст копируется при открытии). Вкладки рендерятся по
// условию и при переключении размонтируются, поэтому переименование участника
// в одной из них другую не задевало: человек возвращался и видел старые имена,
// а список участников в окне переименования расходился между экранами.
// Обе правки сводим сюда и применяем на уровне App — к обоим состояниям сразу.

const renamer = (map) => (label) => {
  const renamed = (map[label] || '').trim();
  return renamed || label;
};

export function renameInTranscriptionState(state, map) {
  if (!state) return state;
  const rename = renamer(map);
  return {
    ...state,
    rawTranscription: applySpeakerRename(state.rawTranscription || '', map),
    parsedTranscription: (state.parsedTranscription || []).map((fragment) => (
      fragment.speaker ? { ...fragment, speaker: rename(fragment.speaker) } : fragment
    )),
    speakers: (state.speakers || []).map(rename),
    speakerIdByLabel: remapKeys(state.speakerIdByLabel, rename),
  };
}

export function renameInProtocolState(state, map) {
  if (!state) return state;
  const rename = renamer(map);
  return {
    ...state,
    transcriptionText: applySpeakerRename(state.transcriptionText || '', map),
    rawTranscriptionText: applySpeakerRename(state.rawTranscriptionText || '', map),
    speakerIdByLabel: remapKeys(state.speakerIdByLabel, rename),
    recognizedSpeakers: (state.recognizedSpeakers || []).map((item) => (
      { ...item, label: rename(item.label) }
    )),
  };
}

// Соответствие «метка на экране → метка диаризации» обязано ехать за
// переименованием, иначе «запомнить голос» перестаёт находить спикера.
function remapKeys(byLabel, rename) {
  const next = {};
  Object.entries(byLabel || {}).forEach(([label, speakerId]) => {
    next[rename(label)] = speakerId;
  });
  return next;
}

// Подтверждение «Это он» тоже обязано быть общим: подтвердили на экране
// протокола — на вкладке транскрибации кнопка должна погаснуть, иначе человек
// подтверждает одного и того же участника дважды и не понимает, засчиталось ли.
export function markSpeakerConfirmed(state, speakerId) {
  if (!state?.recognizedSpeakers) return state;
  return {
    ...state,
    recognizedSpeakers: state.recognizedSpeakers.map((item) => (
      item.speakerId === speakerId ? { ...item, confirmed: true } : item
    )),
  };
}
